import { render } from "./home-page.vue?vue&type=template&id=5143c58c&scoped=true"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"

import "./home-page.vue?vue&type=style&index=0&id=5143c58c&lang=css"
import "./home-page.vue?vue&type=style&index=1&id=5143c58c&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5143c58c"]])

export default __exports__